import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import actions from '../constants';

const useUpdateDatasetSettingsProperties = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ properties }) => handler({
    type: actions.UPDATE_DATASET_SETTINGS_PROPERTIES, category, code, properties,
  }), [category, code]);
};

const useUpdateDatasetSettingsPanels = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ index, panel }) => handler({
    type: actions.UPDATE_DATASET_SETTINGS_PANELS, category, code, index, panel,
  }), [category, code]);
};

export default {
  useUpdateDatasetSettingsProperties,
  useUpdateDatasetSettingsPanels,
};
